import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';

import { sessionExpired } from './Auth/authSlice';
import type { RootState } from './rootReducer';

/** A 401 means the SESSION is dead (expired/invalid/revoked) — not a per-resource denial. */
const isSessionInvalid = (status: unknown): boolean => status === 401;

/**
 * The single place a failed request can end the session. Spreading this across services
 * is how a 403 on one panel logged the whole app out.
 *
 * Dispatched only on a change: a dashboard fires a dozen queries that all 401 at once,
 * and re-dispatching per failure re-renders the shell a dozen times.
 */
export const sessionMiddleware: Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = (action.payload as { status?: unknown } | undefined)?.status;
    if (isSessionInvalid(status) && !(api.getState() as RootState).auth.sessionExpired) {
      api.dispatch(sessionExpired());
    }
  }
  return next(action);
};
